import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import {SettingsMenuTopCategory} from "../../settings-module";
import {Feature} from "../../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../../app/settings/const";

// const debug = "EmailReplyModule"
const debug = false

export class EmailReplyModule extends ModuleProto {

    constructor(moduleConfig:any) {
        super(ModuleType.EMAIL_REPLY, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=",moduleConfig)

        // this._isEnabled               = _.get(moduleConfig,'isEnabled', true)
        this.name                     = "Send Email from Task"
        this.description              = "The Email Reply module enables users to send email notifications to individuals outside of GoodDay directly from the task view screen. This feature facilitates communication with CRM contacts, users who create tasks via email, request form users, and more."
        this.svgIcon                  = "isvg-email-from-task"
        this.settingsMenuTopCategory  = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel                = "CRM"
        this.canDisable               = true
        this.settingsUrl              = "settings/integrations/email-reply"
        this.parentSection            = SettingsParentSection.INTEGRATIONS

        this.feature                    = Feature.EMAIL_REPLY
        this.validateFeature()


        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }


    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)

        const result = super.toJson();

        // if (!this.tasks) {
        //     result.tasks = this.tasks
        // }

        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}
